import { deleteDoc, doc } from 'firebase/firestore';
import { ref, listAll, deleteObject } from 'firebase/storage';
import db , { storage } from '../../firebase' 

const DeleteBtnSite = ({ userEmail, siteName }) => {
    const handleDeleteEverything = async () => {
        if (!userEmail || !siteName) {
          alert('Falta el email o el siteName');
          return;
        }
    
        const confirmed = window.confirm(
          `¿Estás seguro de que quieres eliminar toda la información del sitio "${siteName}"?\nEsta acción no se puede deshacer.`
        );
    
        if (!confirmed) return;
    
        try {     
          await deleteDoc(doc(db, '$:__sites-custumer', userEmail));
          await deleteDoc(doc(db, '$:__sites-name', siteName));
          await deleteDoc(doc(db, '$:__site-monitor', siteName));
          console.log('🔥 Documentos eliminados');
    
          const folderRef = ref(storage, `items/Thumbs/${siteName}/`);
          const list = await listAll(folderRef);    
          const deletePromises = list.items.map((itemRef) => deleteObject(itemRef));
          await Promise.all(deletePromises);
          console.log('🧹 Archivos eliminados de storage');    
          alert('✅ Todo el contenido ha sido eliminado correctamente.');
        } catch (error) {
          console.error('❌ Error eliminando datos:', error);
          alert('Hubo un error eliminando los datos. Mira la consola.');
        }
      };
    
      return (
        <button
          onClick={handleDeleteEverything}
          style={{
            backgroundColor: 'red',
            color: 'white',
            padding: '10px 20px',
            border: 'none',
            borderRadius: '6px',
            cursor: 'pointer',
            fontWeight: 'bold'
          }}
        >
          🗑️ Eliminar Todo
        </button>
      );
    };
    

export default DeleteBtnSite;